module.exports = __webpack_public_path__ + "img/16l007-02.922e87c2.jpg";